export const titleFormStyle = ({ functions: { pxToRem } }) => ({
  fontSize: pxToRem(16),
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
  gap: pxToRem(10),
  cursor: "pointer",
  lineHeight: pxToRem(38),
});

export const subTitleFormStyle = ({ functions: { pxToRem } }) => ({
  fontSize: pxToRem(16),
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: pxToRem(10),
  cursor: "pointer",
  lineHeight: pxToRem(38),
});

export const titleDownload = ({ palette, functions: { pxToRem } }) => ({
  background: "#E8F1F8",
  color: "#172B4D",
  padding: `${pxToRem(8)} ${pxToRem(16)}`,
  textTransform: "none",
  fontSize: pxToRem(14),
  fontWeight: 400,
  borderRadius: pxToRem(8),
  "& svg": {
    marginLeft: pxToRem(10),
  },
  "&:hover": {
    background: "#172B4D",
    color: "#E8F1F8",
  },
});

export const itemList = ({ palette, functions: { pxToRem } }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${pxToRem(8)} ${pxToRem(16)}`,
  borderBottom: `1px solid ${palette.inputBorderColor}`,
});

export const titleItem = ({ functions: { pxToRem } }) => ({
  fontSize: pxToRem(12),
  fontWeight: 700,
  color: "#344767",
  padding: `${pxToRem(8)} ${pxToRem(12)}`,
});

export const subMail = ({ palette, functions: { pxToRem } }) => ({
  fontSize: pxToRem(14),
  fontWeight: 400,
  color: palette.textColors.secondary,
});

export const boxNotiContent = ({ breakpoints, functions: { pxToRem } }) => ({
  display: "flex",
  justifyContent: "space-between",

  [breakpoints.down("md")]: {
    flexDirection: "column",
  },
});

export const groupBoxContent = ({ breakpoints, functions: { pxToRem } }) => ({
  width: "45%",
  [breakpoints.down("md")]: {
    width: "100%",
  },
});

export const container = ({ typography, functions: { pxToRem } }) => ({
  width: "100%",
  "& *": {
    fontFamily: typography.lexendFont,
  },
});

export const groupList = ({ breakpoints, functions: { pxToRem } }) => ({
  width: "45%",

  [breakpoints.down("md")]: {
    width: "100%",
  },
});

export const boxNotiIcon = ({ breakpoints, functions: { pxToRem } }) => ({
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%)",
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(20),

  [breakpoints.down("md")]: {
    display: "none",
  },
});
export const boxButton = ({ palette, typography, functions: { pxToRem } }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: pxToRem(10),
  "& button": {
    padding: "8px 16px",
    fontSize: pxToRem(16),
    fontWeight: 600,
  },
});

export const boxFlex = ({ functions: { pxToRem } }) => ({
  display: "flex",
  alignItems: "center",
  gap: pxToRem(16),
  // overflowX: "auto",
  // overflowY: "visible",
  // whiteSpace: "nowrap", // Prevent wrapping of flex items
  padding: pxToRem(8), // Add padding for better spacing
  // scrollBehavior: "smooth", // Smooth scrolling for better UX
  // "-webkit-overflow-scrolling": "touch", // Smooth scrolling on mobile
  // scrollbarWidth: "none", // Hide scrollbar in Firefox
  // "&::-webkit-scrollbar": {
  //   display: "none", // Hide scrollbar in Webkit browsers
  // },
  // Responsive adjustments
  "@media (max-width: 767px)": {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: pxToRem(8),
    padding: pxToRem(4),
    "& .box-item": {
      width: "100%",
      "&-input, .MuiFormControl-root, button": {
        width: "100%",
      },
    },
  },
  "@media (min-width: 601px) and (max-width: 960px)": {
    gap: pxToRem(12), // Slightly larger gap for tablets
    padding: pxToRem(6),
  },
  "& .md-select__control": {
    color: "#344767",
    "&--is-disabled": {
      background: "#fafafa",
      borderColor: "#e8eaec",
      color: "#a5adbb",
    },
  },
});

export const datetimeInput = ({ functions: { pxToRem } }) => ({
  ".MuiInputBase-formControl": {
    maxHeight: pxToRem(40),
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "rgb(210 214 218) !important",
  },
});

export const wrapEditorStyle = ({ functions: { pxToRem } }) => ({
  "& .disabled": {
    pointerEvents: "none",
    backgroundColor: "#f5f5f5",
    opacity: 0.5,
  },
});

export const wrapInputStyle = ({ functions: { pxToRem } }) => ({
  "& .Mui-disabled": {
    backgroundColor: "#fafafa !important",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(232 234 236)",
    },
  },
});
